import { SlideViewer } from '@live-webinar/view';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/slide-viewer'].update({
        staticData: { title: { page: 'Content.Slides.PageHeading', forWebinar: true } },
        component: authGuard(SlideViewer)
    });
};
